import { PipelineMetrics } from "@/components/dashboard/PipelineMetrics";
import { ProgressChart } from "@/components/dashboard/ProgressChart";
import { RecentActivity } from "@/components/dashboard/RecentActivity";
import { KeyMetrics } from "@/components/dashboard/KeyMetrics";
import { PageTitle } from "@/components/common/PageTitle";
import { useProspects } from "@/hooks/useProspects";

export function Dashboard() {
  const { pipelineStats, isLoading } = useProspects();

  if (isLoading) {
    return (
      <div className="space-y-6">
        <PageTitle title="Dashboard" />
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        </div>
        <div className="flex items-center justify-center py-8">
          <p className="text-muted-foreground">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  if (!pipelineStats) {
    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        </div>
        <div className="flex items-center justify-center py-8">
          <p className="text-muted-foreground">Unable to load dashboard data.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageTitle title="Dashboard" />
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
      </div>

      {/* Main metrics */}
      <PipelineMetrics 
        stageStats={pipelineStats.stageStats} 
        totalProspects={pipelineStats.totalProspects}
      />

      {/* Progress and recent activity */}
      <div className="grid gap-4 md:grid-cols-2">
        <ProgressChart stageStats={pipelineStats.stageStats} />
        <RecentActivity recentActivity={pipelineStats.recentActivity} />
      </div>

      {/* Detailed metrics */}
      <KeyMetrics 
        stageStats={pipelineStats.stageStats} 
        totalProspects={pipelineStats.totalProspects}
      />
    </div>
  );
}